var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.342,
    height: 16.342,
    viewBox: "0 0 16.342 16.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-coins",
    "data-name": "Icon awesome-coins",
    d: "M0,12.937V14.3c0,1.127,2.745,2.043,6.128,2.043s6.128-.916,6.128-2.043V12.937c-1.318.929-3.728,1.363-6.128,1.363S1.318,13.865,0,12.937ZM10.214,4.086c3.383,0,6.128-.916,6.128-2.043S13.6,0,10.214,0,4.086.916,4.086,2.043,6.831,4.086,10.214,4.086ZM0,9.588v1.647c0,1.127,2.745,2.043,6.128,2.043s6.128-.916,6.128-2.043V9.588c-1.318,1.085-3.731,1.647-6.128,1.647S1.318,10.674,0,9.588Zm13.278.351c1.829-.354,3.064-1.012,3.064-1.768V6.808a7.838,7.838,0,0,1-3.064,1.1ZM6.128,5.107C2.745,5.107,0,6.25,0,7.66s2.745,2.553,6.128,2.553,6.128-1.143,6.128-2.553S9.512,5.107,6.128,5.107Zm7,1.8c1.915-.345,3.214-1.021,3.214-1.8V3.744a10.391,10.391,0,0,1-5.129,1.334A3.574,3.574,0,0,1,13.128,6.9Z",
    fill: "#2eafbe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.5f1a6b2f231ccc4a437a7069a4f68147.svg";
export { ForwardRef as ReactComponent };